<template>
  <hr-adaptive-form-dialog
    ref="dialog"
    size="lg"
    class="z-max"
    :title="title"
    @hide="onDialogHide"
    @submit="onSaveNotes"
  >
    <div class="row">
      <hr-text-field
        v-if="plainText"
        v-model="editNotes"
        :label="label"
        outlined
        multiline
        class="full-width"
      />

      <text-editor
        v-else
        v-model="editNotes"
        tables
        indent
        class="full-width"
      />
    </div>

    <template #actions>
      <hr-confirm-btn
        type="submit"
        :label="$t('common.buttonSave')"
        data-e2e="button-save"
      />
    </template>
  </hr-adaptive-form-dialog>
</template>

<script>
import TextEditor from 'components/UI/TextEditor';
import {
  HrAdaptiveFormDialog,
  HrConfirmBtn,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'EditNotes',

  components: {
    HrAdaptiveFormDialog,
    HrConfirmBtn,
    HrTextField,
    TextEditor,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    value: {
      type: String,
      default: null,
    },

    defaultValue: {
      type: String,
      default: '',
    },

    plainText: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: null,
    },
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      editNotes: '',
    };
  },

  methods: {

    show() {
      this.$refs.dialog.show();

      if (this.value === null) {
        this.editNotes = this.defaultValue;
      } else {
        this.editNotes = this.value;
      }
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    onSaveNotes() {
      if (this.editNotes === this.defaultValue) {
        this.$emit('ok', null);
      } else {
        this.$emit('ok', this.editNotes);
      }
      this.hide();
    },
  },
};
</script>
